import React, { useContext, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Col } from '@thd-olt-component-react/core-ui';
import { useConfigService } from '@thd-nucleus/experience-context';
import { isEmpty } from 'lodash';
import { useLocation } from '@thd-olt-component-react/router';
import CreateJobPostingContent from './CreateJobPostingContent';
import { CreateJobPostingButtons } from './CreateJobPostingButtons';
import CreateJobPostingDropDowns from './CreateJobPostingDropDowns';
import CompanyProfile from '../../CompanyProfile/CompanyProfile';
import JobPostingTemplate from '../JobPostingTemplate/JobPostingTemplate';
import CreateJobPostingDatePicker from './CreateJobPostingDatePicker';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import PublishJobPostingDialog
from '../../MyDashboard/JobPostingComponents/PublishJobPostingDialog';
import UnsavedWorkDialog from '../../MyDashboard/JobPostingComponents/UnsavedWorkDialog';

const _CreateJobPostingBody = () => {
  const isJobTemplateEnabled = useConfigService('fs:isJobTemplateEnabled');
  const { editedJobPosting, updateJobPostingField } = useContext(JobPostingContext);

  const [jobDescription, setJobDescription] = useState(' ');
  const [educationAndSkills, setEducationAndSkills] = useState('');
  const [jobDescriptionDirty, setJobDescriptionDirty] = useState(false);
  const [showErrors, setShowErrors] = useState({ draft: false, publish: false });

  const sectionRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    const jobTemplate = location?.state?.jobTemplate;
    if (jobTemplate) {
      setJobDescription(jobTemplate?.jobDescription);
      setEducationAndSkills(jobTemplate?.educationAndSkills);
    }
  }, [location]);

  const scrollToError = () => {
    sectionRef?.current?.scrollIntoView();
  };

  if (isEmpty(editedJobPosting)) {
    return <></>;
  }

  const updateJobDescription = (newValue) => {
    setJobDescription(newValue);
    updateJobPostingField('jobDescription', newValue);
  };

  const updateEducationAndSkills = (newValue) => {
    setEducationAndSkills(newValue);
    updateJobPostingField('educationAndSkills', newValue);
  };

  return (
    <Col>
      <div className="create-job-posting__section" ref={sectionRef}>
        <CreateJobPostingDropDowns showErrors={showErrors} />
        {isJobTemplateEnabled
            && (
              <JobPostingTemplate
                showErrors
                jobDescription={jobDescription}
                setJobDescription={updateJobDescription}
                educationAndSkills={educationAndSkills}
                setEducationAndSkills={updateEducationAndSkills}
                setJobDescriptionDirty={setJobDescriptionDirty}
              />
            )}
        <CreateJobPostingContent
          showErrors={showErrors}
          jobDescription={jobDescription}
          setJobDescription={updateJobDescription}
          educationAndSkills={educationAndSkills}
          setEducationAndSkills={updateEducationAndSkills}
          jobDescriptionDirty={jobDescriptionDirty}
          setJobDescriptionDirty={setJobDescriptionDirty}
        />
        <CompanyProfile showErrors={showErrors} />
        <CreateJobPostingDatePicker />
      </div>
      <CreateJobPostingButtons scrollToError={scrollToError} setShowErrors={setShowErrors} />
      <PublishJobPostingDialog creatingJobPosting />
      <UnsavedWorkDialog scrollToError={scrollToError} setShowErrors={setShowErrors} />
    </Col>
  );
};

export const CreateJobPostingBody = observer(_CreateJobPostingBody);
